import jwt_decode from 'jwt-decode';

import { DecodedToken } from './types';

export const getDecodedRoles = (token: string) => {
  const decoded = jwt_decode<DecodedToken>(token);
  return decoded['https://hasura.io/jwt/claims']['x-hasura-allowed-roles'];
};
